'use client';
import { Filters } from '@/components/filter';
import { QuestionList } from '@/components/question-list';
import StartDiscussionComponent from '@/components/start-discussion-component';
import { useQuestion } from '@/hooks/useQuestion';
import { useState } from 'react';

const DISCUSSION_LIMIT = 10;

export default function DiscussionsTrending() {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  // Use the infinite query instead of the regular query
  const { getInfiniteQuestionsApi, getAllQuestions } = useQuestion({
    limit: DISCUSSION_LIMIT,
    discussionCategoryId: selectedFilters,
    type: 'DISCUSSIONS',
    trending: 'true',
  });

  // Get all questions from all pages
  const questions = getAllQuestions();
  const isLoading = getInfiniteQuestionsApi.isLoading;
  const isFetchingNextPage = getInfiniteQuestionsApi.isFetchingNextPage;
  const hasNextPage = getInfiniteQuestionsApi.hasNextPage;

  return (
    <section className="grid grid-cols-[300px_1fr] gap-12 p-8 max-w-5xl w-full mx-auto">
      <Filters
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        filterType="DISCUSSIONS"
      />

      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-base font-bold text-[#24292E]">
            Trending Discussions
          </h1>
          <p className="text-sm text-gray-500">
            Find the most trending discussions here
          </p>
        </div>
        {questions.length === 0 && !isLoading ? (
          <div className="flex flex-col gap-3 items-center justify-center p-20">
            <p className="text-sm text-gray-500">
              No trending discussions yet—be the first to spark one.
            </p>
            <StartDiscussionComponent />
          </div>
        ) : (
          <QuestionList
            questions={questions}
            isLoading={isLoading}
            hideUserInfo
            hideReport
            // Add infinite scroll props
            isInfiniteScroll={true}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={getInfiniteQuestionsApi.fetchNextPage}
          />
        )}
      </div>
    </section>
  );
}
